module.exports = __webpack_public_path__ + "img/09n.dff48947.png";